import {BREAKPOINTS}from'@manulife/mux';var muxCustomStyles = {
  textInput: {
    rootStyle: {
      width: '100%'
    }
  },
  button: {
    buttonStyle: {
      width: '300px',
      maxWidth: '100%',
      overflowWrap: 'anywhere',
      media: [{
        maximum: BREAKPOINTS.PHONE_PORTRAIT_LG,
        width: '100%'
      }]
    }
  },
  inboundButton: {
    buttonStyle: {
      width: '300px',
      maxWidth: '100%',
      marginTop: '200px',
      media: [{
        maximum: BREAKPOINTS.PHONE_PORTRAIT_LG,
        width: '100%'
      }]
    }
  },
  signInButton: {
    buttonStyle: {
      width: '250px',
      maxWidth: '100%',
      media: [{
        maximum: BREAKPOINTS.PHONE_PORTRAIT_LG,
        width: '100%'
      }]
    }
  },
  oneRowButton: {
    buttonStyle: {
      width: '100px',
      maxWidth: '40%',
      marginRight: '10px',
      minWidth: '160px',
      media: [{
        maximum: BREAKPOINTS.PHONE_PORTRAIT_LG,
        width: '100%',
        marginTop: '10px'
      }]
    }
  },
  legend: {
    legendStyle: {
      padding: '0'
    }
  },
  progressBar: {
    rootStyle: {
      marginTop: '20px'
    },
    progressBarStyle: {
      width: '100%'
    },
    labelStyle: {
      width: '100%'
    }
  },
  dateOfBirth: {
    fieldSetStyle: {
      width: '100%'
    }
  }
};export{muxCustomStyles as default};